import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WebtoonCard from "@/components/feature/WebtoonCard";
import { categories, getCategory } from "@/mocks/categories";
import { getWebtoonsByCategory } from "@/mocks/webtoons";

export default function CategoryDetail() {
  const { slug = "sweet" } = useParams();
  const cat = getCategory(slug);

  useEffect(() => { document.title = `${cat.name}·免费韩漫高分榜单 · 漫糖韩漫`; }, [cat]);

  const list = getWebtoonsByCategory(slug);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="bg-foreground-950">
        <div className="mx-auto max-w-7xl px-4 pb-10 pt-24 md:px-6 md:pt-28">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-background-400">
            <Link to="/" className="hover:text-background-100">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/category" className="hover:text-background-100">热门分类</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-200">{cat.name}</span>
          </nav>
          <div className="mt-5 flex flex-col items-start gap-4 md:flex-row md:items-center">
            <span className={`flex h-14 w-14 items-center justify-center rounded-2xl text-background-50 ${cat.color}`}>
              <i className={`${cat.icon} text-2xl`}></i>
            </span>
            <div>
              <h1 className="font-heading text-3xl text-background-50 md:text-4xl">{cat.name} · 免费韩漫高分榜单</h1>
              <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-background-300">{cat.desc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* category chips */}
      <div className="sticky top-16 z-30 border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center gap-2 overflow-x-auto px-4 py-3 md:px-6">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className={`shrink-0 rounded-full px-4 py-1.5 text-sm whitespace-nowrap transition-colors ${
                c.slug === slug ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {c.name}
            </Link>
          ))}
        </div>
      </div>

      <section className="mx-auto max-w-7xl px-4 py-10 md:px-6">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold text-foreground-950">
            本类人气推荐 <span className="text-sm font-normal text-foreground-500">({list.length}部)</span>
          </h2>
          <span className="text-sm text-foreground-500">按人气与评分实时排序</span>
        </div>

        {list.length > 0 ? (
          <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {list.map((w) => (
              <WebtoonCard key={w.id} item={w} />
            ))}
          </div>
        ) : (
          <div className="mt-10 rounded-3xl border border-dashed border-background-300 bg-background-100 p-12 text-center">
            <i className="ri-inbox-line text-4xl text-foreground-400"></i>
            <p className="mt-3 text-foreground-600">该分类的作品正在整理中,敬请期待</p>
            <Link to="/category" className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
              返回全部分类 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        )}

        <div className="mt-10 flex items-center justify-center">
          <Link
            to="/ranking"
            className="flex items-center gap-2 rounded-full bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600"
          >
            <i className="ri-trophy-fill"></i>
            查看完整人气排行榜
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}